import React, {useEffect, useState} from "react"
import '@opentok/client'

const usePublisher = ({
                          containerRef = null,
                          audioBitrate = 510000,
                          audioSource = null,
                          autoGainControl = false,
                          fitMode = 'cover',
                          height = '100%',
                          insertMode = 'append',
                          mirror = false,
                          name = '',
                          publishAudio = true,
                          publishVideo = true,
                          resolution = '1280x720',
                          showControls = false,
                          videoSource = null,
                          width = '100%'
}) => {
    const [publisher, setPublisher] = useState(null)


    useEffect(() => {
        if (containerRef
            && containerRef.current
            && !publisher
            && videoSource
            && audioSource
        ) {
            const publisher = OT.initPublisher(containerRef.current, {
                audioBitrate,
                audioSource,
                autoGainControl,
                fitMode,
                height,
                insertMode,
                mirror,
                name,
                publishAudio,
                publishVideo,
                resolution,
                showControls,
                videoSource,
                width,
            })
            setPublisher(publisher)
        }
    }, [
        containerRef,
        audioBitrate,
        audioSource,
        autoGainControl,
        fitMode,
        height,
        insertMode,
        mirror,
        name,
        publishAudio,
        publishVideo,
        resolution,
        showControls,
        videoSource,
        width,
        publisher,
    ])

    useEffect(() => {
        return () => {
            if(publisher) {
                publisher.destroy()
            }
        }
    }, [])

    useEffect(() => {
        if(publisher) {
            publisher.setVideoSource(videoSource)
        }
    }, [videoSource])

    useEffect(() => {
        if(publisher) {
            publisher.setAudioSource(audioSource)
        }
    }, [audioSource])


    return publisher
}

export default usePublisher
